/* Renders PayPal Pay Later buttons for any .adv-paylater[data-paypal-amount] on the page.
   Loads the PayPal SDK once, on demand. Used on product pages and product grids. */
(function () {
  var SDK = "https://www.paypal.com/sdk/js?client-id=AZfqzoxgQFfMRk2LRhMD_-yBwknpdi6wlOGTulqBzmusaESwlrSQ440_92FEWCk6hjb5lZPnjH4cI82a&components=buttons,funding-eligibility,messages&currency=USD&enable-funding=paylater";
  var loading = false, waiters = [];

  function loadSDK(cb) {
    if (window.paypal && window.paypal.Buttons) { cb(); return; }
    waiters.push(cb);
    if (loading) return;
    loading = true;
    var s = document.createElement('script');
    s.src = SDK;
    s.onload = function () { waiters.forEach(function (f) { f(); }); waiters = []; };
    s.onerror = function () { loading = false; };
    document.head.appendChild(s);
  }

  function statusUpdate(box, text, ok) {
    if (!box) return;
    box.textContent = text;
    box.style.display = 'block';
    box.style.backgroundColor = ok ? '#E6F4EA' : '#FCE8E6';
    box.style.color = ok ? '#137333' : '#C5221F';
  }

  function renderOne(el) {
    if (el.getAttribute('data-pp-done')) return;
    el.setAttribute('data-pp-done', '1');
    var amount = el.getAttribute('data-paypal-amount');
    var compact = el.getAttribute('data-paypal-compact') === 'true';
    var msg = el.querySelector('.adv-paylater__msg');
    var btn = el.querySelector('.adv-paylater__btn');
    var status = el.querySelector('.adv-paylater__status');
    if (!compact && window.paypal.Messages && msg) {
      paypal.Messages({ amount: amount, placement: 'product' }).render(msg);
    }
    function makeOrder(d, a) { return a.order.create({ purchase_units: [{ amount: { value: amount } }] }); }
    function onApprove(d, a) {
      return a.order.capture().then(function (det) {
        statusUpdate(status, "✓ Success! Paid by " + det.payer.name.given_name, true);
      });
    }
    paypal.Buttons({
      style: { layout: 'horizontal', shape: 'rect', color: 'gold', label: 'buynow', height: 48, tagline: false },
      createOrder: makeOrder,
      onApprove: onApprove,
      onError: function (e) { console.error(e); statusUpdate(status, "⚠ Error during checkout.", false); }
    }).render(btn);
  }

  function renderAll() {
    var els = document.querySelectorAll('.adv-paylater[data-paypal-amount]:not([data-pp-done])');
    if (!els.length) return;
    loadSDK(function () { Array.prototype.forEach.call(els, renderOne); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }
  document.addEventListener('shopify:section:load', renderAll);
})();
